import React from "react";
import Sidebar from "@/components/Sidebar";
import TrialBanner from "@/components/TrialBanner";

export default function AppLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <TrialBanner />
        <main className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
}
